import { Controller, useFormContext, useWatch } from 'react-hook-form';
import { TASK_FORM_FIELDS } from '../../../../../helpers/form';
import { WBFlex, WBTextFieldV2 } from '@admiin-com/ds-web';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useTaskCreationContext } from '../../../../providers/TaskCreationProvider/useTaskCreationContext';
import { useClientFirmUsers } from '../../../../../hooks/useClientFirmUsers/useClientFirmUsers';

export const TaxEmailMessage = () => {
  const { t } = useTranslation();
  const { control, setValue } = useFormContext();
  const { client } = useTaskCreationContext();
  const { firmEntityUser, partnerEntityUser, managerEntityUser, currentUser } =
    useClientFirmUsers(client);
  const to = useWatch({ name: 'to', control });

  const toFirstName = to?.firstName ?? to?.contact?.firstName ?? to?.name ?? '';

  const signOffName = partnerEntityUser
    ? `${partnerEntityUser.firstName ?? ''} ${
        partnerEntityUser.lastName ?? ''
      }`.trim()
    : managerEntityUser
    ? `${managerEntityUser.firstName ?? ''} ${
        managerEntityUser.lastName ?? ''
      }`.trim()
    : `${firmEntityUser?.firstName ?? currentUser?.firstName ?? ''} ${
        firmEntityUser?.lastName ?? currentUser?.lastName ?? ''
      }`.trim();

  const emailMessage = React.useMemo(
    () =>
      `Hi ${toFirstName},

Please review and sign your latest tax lodgements below. If you have any questions or need any clarification, please don't hesitate to reach out.

Kind regards,
${signOffName}`,
    [toFirstName, signOffName]
  );

  React.useEffect(() => {
    setValue('emailMessage', emailMessage);
  }, [emailMessage, setValue]);

  const inputs = React.useMemo(
    () => ({
      emailMessage: {
        ...TASK_FORM_FIELDS.emailMessage,
        defaultValue: emailMessage,
        label: t('taxEmailMessage', { ns: 'taskbox' }),
        placeholder: t('emailMessagePlaceholder', { ns: 'taskbox' }),
      },
    }),
    [emailMessage, t]
  );

  return (
    <WBFlex flexDirection="column" flex={1}>
      <Controller
        control={control}
        name={inputs.emailMessage.name}
        defaultValue={inputs.emailMessage.defaultValue}
        render={({ field, fieldState }) => (
          <WBTextFieldV2
            {...field}
            label={inputs.emailMessage.label}
            placeholder={inputs.emailMessage.placeholder}
            multiline
            rows={6}
            fullWidth
            error={fieldState.invalid}
            helperText={fieldState.error?.message}
          />
        )}
      />
    </WBFlex>
  );
};
